import { useState } from "react";
import { DocIcon } from "./Icons";

const ALLOWED = /\.(pdf|png|jpe?g)$/i;

export const UploadZone = ({ id, bureau, file, onFile }) => {
  const [drag, setDrag] = useState(false);
  const [err, setErr] = useState("");

  const take = (f) => {
    if (!f) return;
    if (!ALLOWED.test(f.name)) {
      setErr("PDF, PNG or JPG only.");
      return;
    }
    setErr("");
    onFile(f);
  };

  return (
    <div
      className={`upload-zone${drag ? " drag-over" : ""}${file ? " has-file" : ""}`}
      data-testid={`upload-zone-${id}`}
      onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={(e) => { e.preventDefault(); setDrag(false); take(e.dataTransfer.files?.[0]); }}
    >
      <input type="file" accept=".pdf,.png,.jpg,.jpeg" aria-label={`${bureau} credit report`}
        data-testid={`upload-input-${id}`} onChange={(e) => take(e.target.files?.[0])} />
      <div className="bureau-tag">{bureau}</div>
      <DocIcon />
      <div className="upload-lbl">{file ? "Attached" : "Click or drag to upload"}</div>
      {file && <div className="upload-fn" data-testid={`upload-filename-${id}`}>{file.name}</div>}
      {err && <div className="field-error">{err}</div>}
    </div>
  );
};
